import { FC, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { Accounting } from '../../../lib/Types'
import Headline from '../../Elements/Headline'
import LoadingSpinner from '../../Elements/LoadingSpinner'
import AccountingDevelopmentChart from './AccountingDevelopmentChart'

interface Props {
  accounting: Accounting
}

const AccountingDevelopment: FC<Props> = ({ accounting }) => {
  const { t } = useTranslation(['accounting'])

  return (
    <>
      <Headline>{t('accounting:development.heading')}</Headline>
      <p className='mt-2 mb-5'>{t('accounting:development.description')}</p>
      <Suspense fallback={<LoadingSpinner />}>
        <AccountingDevelopmentChart
          accounting={accounting}
          showCategories={true}
        />
      </Suspense>
    </>
  )
}

export default AccountingDevelopment
